exports.install = function (Vue, options) {
	//获取问题类型
	Vue.prototype.getOpiniontype = function(value={})
	{
		return this.axiosget("/api/Opiniontype/getList",value)
		.then((response)=>{
			return response;
		})
	};
	//添加反馈
	Vue.prototype.addopinion = function(value)
	{
		return this.axiospost("/api/Opinion/add",value)
		.then((response)=>{
			return response;
		});
	};
}